import { LoadingState, LoadingStates, Poi } from '../poi';
import { types } from 'mobx-state-tree';
import { fetchMyLocationsList } from './flows/fetch-my-locations';
import { addMyLocation } from './flows/add-my-location';
import { removeMyLocation } from './flows/remove-my-location';

const ErrorWrapper = types.model('ErrorWrapper', {
  alreadyExists: types.boolean,
  description: types.boolean,
  title: types.boolean,
});

export const MyLocationsStore = types
  .model({
    status: types.optional(LoadingState, LoadingStates.init),
    list: types.optional(types.array(Poi), []),
    addingLocationFlow: types.optional(types.boolean, false),
    newPoi: types.optional(types.array(types.number), []),
    errors: ErrorWrapper,
    selected: types.optional(types.array(Poi), []),
    selectable: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    fetch: (...args) => fetchMyLocationsList(self, ...args),
    activate: () => (self.addingLocationFlow = true),
    deactivate: () => (self.addingLocationFlow = false),
    selectNewPoi: (coords) => (self.newPoi = coords),

    add: (...args) => addMyLocation(self, ...args),
    remove: (...args) => removeMyLocation(self, ...args),
    setError: (key, value) => (self.errors[key] = value),
    select: (poi) => {
      if (
        self.selected.filter((selected) => selected.id === poi.id).length === 0
      )
        self.selected = self.selected.concat(JSON.parse(JSON.stringify(poi)));
    },
    deselect: (poi) =>
      (self.selected = self.selected.filter(
        (selected) => selected.id !== poi.id,
      )),
    deselectAll: (...args) => {
      self.selected = [];
    },
    setSelectable: (selectable) => {
      self.selectable = selectable;
    },
  }));

export const initialState = {
  list: [],
  errors: {
    alreadyExists: false,
    description: false,
    title: false,
    color: false,
    category: false
  },
};
